import { render, staticRenderFns } from "./DashboardProfileSection.vue?vue&type=template&id=714228ea&scoped=true&"
import script from "./DashboardProfileSection.vue?vue&type=script&lang=ts&"
export * from "./DashboardProfileSection.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardProfileSection.vue?vue&type=style&index=0&id=714228ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714228ea",
  null
  
)

export default component.exports